import { Divider } from "@mui/material";
import CheckboxTree from "designSystem/components/checkbox/CheckboxTree";
import RadioGroup from "designSystem/components/radio/RadioGroup";
import { Checkbox, FlexRowCenter, GridColumn, OverflowText, SearchPlaceholder, SearchTextField, Text } from "designSystem/index";
import { grey } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useMassUpdateStyleSizeChartStore } from "./MassUpdateStyleSizeChartStore";

export const MassUpdateStyleSizeChartSettingsForm: FunctionComponent = observer(() => {
	const store = useMassUpdateStyleSizeChartStore();
	const { createRevision, onCreateRevision, pushAllOption, uniqueIds, onSearchTextChange, onUpdateOption, massUpdateOptionName, massUpdateOptions, isLockShapeDimensionList, searchedItems, searchText, treeStore } = store;
	const handleChange = (event: object, value: boolean) => {
		onCreateRevision(value);
	};
	return (
		<GridColumn scroll spacing={4}>
			<Text res="MassUpdateSettings" variant="h6" />
			<RadioGroup
				name={massUpdateOptionName}
				onChange={onUpdateOption}
				options={massUpdateOptions}
				value={pushAllOption}
			/>
			<Checkbox
				checked = {createRevision}
				labelProps={{
					res: "CreateNewRevision",
				}}
				onChange={handleChange}
			/>
			<Divider />
			<Text res="MassUpdateStylesSizeChart_SelectShapeDimensions" variant="h6" />
			{!isLockShapeDimensionList && (
				<SearchTextField
					fullWidth
					onChange={onSearchTextChange}
					placeholderRes="Search"
					value={searchText}
				/>
			)}
			{searchedItems.length > 0 ? (
				<CheckboxTree
					branchSpacing={2}
					defaultExpanded={uniqueIds}
					disabled={isLockShapeDimensionList}
					displayCounts
					store={treeStore}
				/>
			) : (
				<SearchPlaceholder 
					titleProps={{ res: "SEARCH_NO_RESULTS" }}
				/>
			)}
		</GridColumn>
	);
});

interface DimDividerProps {
	name: string;
}
export const DimDivider = (props: DimDividerProps) => {
	const { name } = props;

	return (
		<FlexRowCenter
			flexGrow={1}
			p={1}
			sx={{
				backgroundColor: grey[200],
			}}
		>
			<OverflowText
				bold
				text={name}
			/>
		</FlexRowCenter>
	);
};